export const splitFileName = (file: File, part: "name" | "type") => {
  const fileTypeSplitterIndex = file.name.lastIndexOf(".");
  return part === "name"
    ? file.name.substring(0, fileTypeSplitterIndex)
    : file.name.substring(fileTypeSplitterIndex + 1);
};
